<template>
  <div class="app-container">
    <list ref="list" :can-price="canPrice">
      <template slot="toolbar-right" v-if="canWrite">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{row}">
            <el-button v-if="canWrite && row.Status !== 2" @click="edit(row)" type="text">
              编辑
            </el-button>
            <el-button v-if="canReview && row.Status == 2" type="text" @click="edit(row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/productionshipping/list'


export default {
  name: "bom",
  mixins: [curdMixins],
  components: {
    list,
  },
  data() {
    return {
      api: require("@/api/stock/stInDoc").default,
    }
  },
  computed: {
    canWrite() {
      return this.$permission.canWrite();
    },
    canPrice() {
      return this.$permission.canPrice();
    },
    canReview() {
      return this.$permission.canReview();
    },
  },
  methods: {
    edit({ DocId }) {
      let id = DocId;
      this.api.info(id).then(res => {
        if (res.Code === 0) {
          this.toURL({
            name: 'editinjectionmolding',
            params: {
              type: 'edit',
              data: res.Data
            }
          })
        }
      })
    },
    create() {
      this.toURL({
        name: 'editinjectionmolding',
        params: {
          type: 'create'
        }
      })
    },
    toURL(o) {
      this.$router.push(o)
    }
  }
};
</script>